import { fetchAuthSession } from "aws-amplify/auth";
import { SystemError, SystemErrorTitle, SystemErrorMsg } from "../../constants";
import executeApi from './executeApi';
import { SearchCrudApiRequest } from "../model/apiRequestModel";
import { SearchCrudApiResponse } from "../model/apiResponseModel";

/** 汎用操作 */
const crud = async (requestObj: SearchCrudApiRequest): Promise<SearchCrudApiResponse> => {
    // 認証
    const session = await fetchAuthSession();
    const jwtToken = session.tokens?.idToken?.toString();
    // EyesFrontAPIのURLを取得
    const baseURL = process.env.REACT_APP_EYES_FRONT_API_ROOT!;
    // 汎用操作API PATH
    const path = "/search/crud/execution";

    // limitとoffsetが未設定の場合はnullで補完する
    if (!requestObj.limit) {
        requestObj.limit = null
    }
    if (!requestObj.offset) {
        requestObj.offset = null
    }
    const request = JSON.stringify(requestObj)

    try {
        const response = await executeApi(baseURL, path, jwtToken, 0, request);
        // レスポンスコード返却
        if (!response || response.data.res_cd == "") {
            return {
                resCd: SystemError,
                msgTitle: SystemErrorTitle,
                msg: SystemErrorMsg
            }
        } else {
            const result: SearchCrudApiResponse = response.data
            return result
        }
    } catch (e) {
        return {
            resCd: SystemError,
            msgTitle: SystemErrorTitle,
            msg: SystemErrorMsg
        };
    }
};

export default crud;
